module.exports = __webpack_public_path__ + "static/img/nanjindaxue.7ff2664.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/nanjindaxue.png
// module id = N9FH
// module chunks = 36